
import { Vue, Component } from "vue-property-decorator";
import AIQaEdit from "./components/ai-qa-edit.vue";
import IntelligentQA, {
  AIQaPair,
  IS_DISABLED,
  IS_DISABLED_SEARCH_DICT,
  getIsDisabledLabel,
  getIsDisabledTagType
} from "@/lib/model/intelligentQA/index";
import AskGoOn from "@/components/ask-go-on.vue";

@Component({
  components: {
    AIQaEdit,
    AskGoOn
  }
})
export default class AIQaOfficerList extends Vue {
  form = {
    qaIdList: [],
    isDisabled: 0,
    searchText: "",
    pageNum: 1,
    pageSize: 10
  };
  total = 0;
  loading = false;

  IS_DISABLED_SEARCH_DICT = IS_DISABLED_SEARCH_DICT;
  IS_DISABLED = IS_DISABLED;
  getIsDisabledTagType = getIsDisabledTagType;
  getIsDisabledLabel = getIsDisabledLabel;

  visible = false;
  tableData: any = [];

  confirmShow = false;
  currentConfirm = IS_DISABLED.DISABLE;
  confirmConfig = {
    [IS_DISABLED.DISABLE]: {
      title: "确认停用问题吗？",
      content: "停用后所有使用该问题的面试答疑官都会同步停用，请确认",
      changedStatus: IS_DISABLED.DISABLE // 点击确认后状态更新的值
    },
    [IS_DISABLED.ENABLE]: {
      title: "确认启用问题吗？",
      content: "启用后所有使用该问题的面试答疑官都会同步启用，请确认",
      changedStatus: IS_DISABLED.ENABLE // 点击确认后状态更新的值
    }
  };

  created(): void {
    this.onSearch();
  }

  onSearch(): void {
    this.form.pageNum = 1;
    this.getList();
  }

  onCurrentChange(value: number): void {
    this.form.pageNum = value;
    this.getList();
  }

  async getList(): Promise<void> {
    const res = await IntelligentQA.list(this.form);
    console.log("🚀 ~ AIQaOfficerList ~ getList ~ res:", res);
    this.total = res.total;
    this.form.pageNum = res.pageNum;
    this.tableData = res.list;
  }

  addQuestion(): void {
    this.rowData = {} as any;
    this.visible = true;
  }

  rowData = {} as AIQaPair;
  editQuestion(row: any): void {
    console.log(row);
    this.rowData = row;
    this.visible = true;
  }

  onDisableStatus(row: any): void {
    this.onToggleStatus(row, true);
  }

  onEnableStatus(row: any): void {
    this.onToggleStatus(row, false);
  }

  // 提示框 ok
  async onConfirmOk(): Promise<void> {
    if (this.loading) return;
    this.loading = true;
    const req = {
      isDisabled: this.confirmConfig[this.currentConfirm].changedStatus,
      qaId: this.rowData.id
    };
    try {
      await IntelligentQA.toggleStatus(req);
      this.$message.success("问题状态更新成功");
      this.onSearch();
    } catch (e) {
      const msg = e?.data?.message || "问题状态更新失败";
      this.$message.error(msg);
    } finally {
      this.loading = false;
      this.rowData = {} as any;
      this.confirmShow = false;
    }
  }

  onToggleStatus(row: any, isDisabled: boolean): void {
    isDisabled
      ? (this.currentConfirm = IS_DISABLED.DISABLE)
      : (this.currentConfirm = IS_DISABLED.ENABLE);
    this.rowData = row;
    this.confirmShow = true;
  }
}
